export default __webpack_public_path__ + "static/media/certificate3.23b1f3f7.svg";